<template>
	<b-card no-body class="card-statistics">
		<b-overlay :show="isFetchingRecordsFromServer" :variant="'transparent'" :opacity="'1'" :blur="'2px'" rounded="sm">
			<b-card-header>
				<b-card-title>Filters</b-card-title>
			</b-card-header>
			<b-card-body>
				<b-row>

					<b-col class="m-50" xl="3" sm="12">
						<Select2 v-model="selectedSite" :options="userSitesDropDownArray" @change="selectUserSiteChangeEvent($event)" placeholder="Select Site" />
					</b-col>

					<b-col class="m-50" xl="2" sm="12">
						<Select2 v-model="dateTypeValue" :options="dateTypeOptions" @change="dropDownDateTypeChangeEvent($event)" />
					</b-col>

					<b-col class="m-50" xl="3" sm="12" v-if="dateTypeValue == 'custom_date'">
						<VueCtkDateTimePicker :id="'customDateTypeFilter_'+_uid" v-model="customDateTypeFilter" :overlay="true" :noShortcuts="true" :range="true" :onlyDate="true" :time="false" format="MM/DD/YYYY" formatted="ll" @is-hidden="onHideChangeCustomDateEvent" />
					</b-col>

				</b-row>
			</b-card-body>
		</b-overlay>
	</b-card>
</template>
<script>
	import dateTypeListOptions from "@/libs/dateTypeListOptions";
	import {
		BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BLink, BOverlay, BFormCheckbox, BFormGroup
	} from 'bootstrap-vue';
	export default {
		components: {
			BRow, BCol, BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BMedia, BAvatar, BMediaAside, BMediaBody, BOverlay, BFormCheckbox, BFormGroup
		},
		data() {
			return {
				isFetchingRecordsFromServer: false,
				dateTypeValue: 'today',
				customDateTypeFilter: '',
				userSitesDropDownArray: [],
				userSitesArray: [],
				filterSitesArray: [],
				selectedSite: '',
			}
		},
		created() {
			this.getDefaultFilterElements(); /* FETCH FILTER FROM VUEX */
			this.fetchUserSites();
		},
		methods: {
			fetchUserSites() {
				this.isFetchingRecordsFromServer = true;
				this.$globalAPI.get('site/list', {
					status: 1,
					user_id: this.$root.authUserObject?.id
				}).then((response) => {
					response = response.data;
					if (response.status) {
						let sortedSitesArray = _.sortBy(response.sites, "siteURL");
						for (const site of sortedSitesArray) {
							this.userSitesDropDownArray.push({
								'id': site.siteId,
								'text': site.siteURL,
							});
						}
						this.userSitesArray = sortedSitesArray;

						if (!_.isEmpty(sortedSitesArray)) {
							let firstSite = _.first(sortedSitesArray);
							this.filterSitesArray = firstSite;
							this.selectedSite = this.$root.appSiteObject.siteId; /* SELECTED FIRST SITE AND CALL CHANGE EVENT */
						}
					}
					this.isFetchingRecordsFromServer = false;
					this.selectUserSiteChangeEvent(this.$root.appSiteObject.siteId)
				});
			},
			dropDownDateTypeChangeEvent(val) {
				if (this.dateTypeValue != 'custom_date') {
					this.fetchCountStatisticsItems();
				}

				/* STORE FILTER IN VUEX AND DB : START */
				this.$root.setDefaultFilterElements({
					page: 'mobileVsDesktopReport',
					filterObject: {
						'date_type': val,
					},
				});
				/* STORE FILTER IN VUEX AND DB : END */

			},
			onHideChangeCustomDateEvent() {
				if (!_.isEmpty(this.customDateTypeFilter)) {
					this.fetchCountStatisticsItems();

					/* STORE FILTER IN VUEX AND DB : START */
					this.$root.setDefaultFilterElements({
						page: 'mobileVsDesktopReport',
						filterObject: {
							'date_type_custom_filter': this.customDateTypeFilter,
						},
					});
					/* STORE FILTER IN VUEX AND DB : END */

				}
			},
			selectUserSiteChangeEvent(siteId) {
				this.filterSitesArray = _.first(_.filter(this.userSitesArray, (item) => { /* FOR FILTER SITES WITH SEARCH */
					return ((item.siteId == siteId) ? true : false);
				}));
				this.fetchCountStatisticsItems();
			},
			fetchCountStatisticsItems() {

				this.$emit('selectedFilter', {
					'site': this.filterSitesArray,
					'selectedSite': this.selectedSite ?? '',
					'date_type': this.dateTypeValue,
					'date_type_custom_filter': (this.customDateTypeFilter ? JSON.stringify(this.customDateTypeFilter) : ''),
				});

			},

			/**
			* GET FILTER FROM VUEX AND SET INTO ELEMENTS
			*/
			getDefaultFilterElements() {
				let filterObject = this.$store.getters['appModuleFilters/getFilter']({
					page: 'mobileVsDesktopReport',
				});
				/* FETCH FILTER FROM VUEX : END */
				this.dateTypeValue = filterObject.date_type;
				this.customDateTypeFilter = filterObject.date_type_custom_filter;
			}
		},
		setup() {

			const {
				dateTypeOptions,
			} = dateTypeListOptions()

			return {
				dateTypeOptions
			}
		},
	}
</script>